
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'plans-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'plans-bundle')

export default [
  {
    name: 'plans.index',
    path: '/plans',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'plans.new',
        path: 'create',
        component: Form,
        meta: { requiresAuth: true }
      },
      {
        name: 'plans.edit',
        path: ':id/edit',
        component: Form,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/plans/routes.js